import React from "react";
import { Input } from "antd";
const Box = ({ value1, set1, value2, set2, value3, set3, value4, set4 }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Input
        size="large"
        defaultValue={""}
        value={value1}
        onChange={(e) => set1(e.target.value)}
      />
      <Input
        size="large"
        defaultValue={""}
        value={value2}
        onChange={(e) => set2(e.target.value)}
      />
      <Input
        size="large"
        defaultValue={""}
        value={value3}
        onChange={(e) => set3(e.target.value)}
      />
      <Input
        size="large"
        defaultValue={""}
        value={value4}
        onChange={(e) => set4(e.target.value)}
      />
    </div>
  );
};

export default Box;
